module.exports = __webpack_public_path__ + "static/media/quince_jam.e76e0e49.png";